import { FC } from 'react';
import { Typography } from 'antd';

import './index.scss';

export const Loading: FC = () => {
	return (
		<div className="loading">
			<Typography.Title className="loading__title" level={3}>
				Crowdpear
			</Typography.Title>
			<Typography.Text>Loading...</Typography.Text>
		</div>
	);
};
